var React = require('react');

function Cg (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-79.5 32h640v480h-640z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"translate(79.5 -32)","key":1},[React.createElement("path",{"fill":"#ff0","d":"M-119.5 32h720v480h-720z","key":0}),React.createElement("path",{"fill":"#00ca00","d":"M-119.5 32v480l480-480h-480z","key":1}),React.createElement("path",{"fill":"red","d":"M120.5 512h480V32l-480 480z","key":2})])]);
}

Cg.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Cg;

Cg.default = Cg;
